import apiUrl from '../../../../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import Paginate from 'vuejs-paginate';
import VueElementLoading from 'vue-element-loading';

export default {
  name: 'approvalflow',
  components: {
    VueElementLoading,
    module,
    Paginate,
  },
  props: [],
  data: function() {
    return {
      searchapproval : "",
      approvalListing : [],
      isLoading:false,
      isLoading1:false,
      pageno: 1,
      pagecount: 1,
      resultCount : 0,
      changepopupStatusFlag : false,
      changeStatsuData : '',
      localuserid : '',
      useremail : '',
      userrole : '',
      project : '',
      username : '',
      clientInfoPopup : false,
      clientInfoData :  [],
      gstDetailes : [],
      spocDetails : [],
      rejectReson : '',
      commnet : '',
      opened: [],
      approvalstatus1 : '',
      BusinessConfig : ''
    }
  },
  computed: {

  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = parseInt(userdetail.userid);
    this.useremail = userdetail.email;
    // this.userrole = userdetail.userrole;
    this.userrole = userdetail.rolename[0];
    this.username = userdetail.username;
    this.project = userdetail.project;
    this.searchapprovalitem();
    this.traseIP();
  },
  methods: {
    searchapprovalitem(){
      let userToken = window.localStorage.getItem('cargoAutoaccessuserdata');
      let myStr = userToken.replace(/"/g, '');
      this.approvalListing = [];
      let data = {
        offset : this.pageno,
        limit : 10,
        project : this.project
      }
      if(this.searchapproval){
        data.filter = this.searchapproval;
      }
      this.isLoading = true;
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'approval/approvallist',
          'data': data,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then((response) => {
          this.isLoading = false;
          if (response.data.code == 200) {
            this.approvalListing = response.data.data;
            let totalRows = response.data.count;
            this.resultCount = response.data.count;
            if (totalRows < 10) {
                this.pagecount = 1;
            } else {
                this.pagecount = Math.ceil(totalRows / 10)
            }
            //this.$alertify.success(response.data.message)
          } else {
            //this.$alertify.error(response.data.message)
            this.$alert(response.data.message,"","error");
          }
        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        })
    },
    getPaginationData(pageNum) {
      this.pageno = pageNum;
      this.searchapprovalitem();
    },
    openPopupForapprove(approve){
      this.changepopupStatusFlag = true;
      this.approvalstatus1 = approve;
    },
    getClientInfo(clientData){
      //this.clientInfoPopup = true;
      this.isLoading1 = true;
      this.changeStatsuData = clientData;
      this.traseIP();
      const index = this.opened.indexOf(clientData.ClientMasterID);
      if (index > -1) {
        this.opened.splice(index, 1)
      } else {
        this.opened = [];
        this.opened.push(clientData.ClientMasterID)
      }
      let userToken = window.localStorage.getItem('cargoAutoaccessuserdata');
      let myStr = userToken.replace(/"/g, '');
      let data = {
        clientMasterID : clientData.ClientMasterID
      }
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'approval/getClientInfo',
          'data': data,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then((response) => {
          this.isLoading1 = false;
          if (response.data.code == 200) {
            this.clientInfoData = response.data.data;
            this.gstDetailes = response.data.data.GSTDetails;
            this.spocDetails = response.data.data.SpocDetails;
            this.BusinessConfig = this.clientInfoData.BusinessConfig.BusinessConfig;
            for (var i = 0; i < this.spocDetails.length; i++) {
              let contactNo =this.spocDetails[i].ContactNo;
              this.spocDetails[i].ContactNo=contactNo.slice(0, 5) + " " + contactNo.slice(5);;
            }
            //this.$alertify.success(response.data.message)
          } else {
            //this.$alertify.error(response.data.message)
            this.$alert(response.data.message,"","error");
          }
        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        })
    },
    DownloadFile(filePath){
      var link = document.createElement('a');
      link.href = filePath;
      link.setAttribute('target','_blank');
      window.open(filePath, '_blank');
      return true;
    },
    cancelmodal() {
      this.changepopupStatusFlag = false;
      //this.changeStatsuData = '';
      this.approvalstatus1 = '';
      this.rejectReson = '';
      this.commnet = '';
      this.$validator.reset();
    },
    rejectClientBusinessStatusAddComment(approve){
      this.approvalstatus1 = approve;
    },
    changeClientBusinessStatus(approve){
      this.changepopupStatusFlag = false;
      let userToken = window.localStorage.getItem('cargoAutoaccessuserdata');
      let myStr = userToken.replace(/"/g, '');
      this.traseIP();
      this.approvalstatus1 = approve;
      let data = {
        approvalmasterid : this.changeStatsuData.approvalmasterid,
        modulemasterid : this.changeStatsuData.modulemasterid,
        userrolemasterid : this.changeStatsuData.userrolemasterid,
        modulename : this.project,
        userid : this.localuserid,
        username : this.username,
        email : this.useremail,
        // approvalstatus1 : this.changeStatsuData.approvalstatus1,
        approvaluserid : this.changeStatsuData.ClientMasterID,
        status : approve
      }
      if(this.rejectReson) data.rejectReson = this.rejectReson;
      if(this.commnet) data.commnet = this.commnet;

      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'approval/changeApprovalSatus',
          'data': data,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        }).then((response) => {
          this.opened.splice(0, 1)
          this.isLoading = true;
          this.cancelmodal();
          this.pageno = 0;
          this.pagecount = 0;
          this.resultCount = '';
          this.$refs.paginate.selected = 0;
          this.$validator.reset();
          this.searchapprovalitem();
          // if (approve == 'approve') {
          //   this.$alert(response.data.message,"","success");
          // }else {
          //   this.$alert('successfully Reject',"","success");
          // }
          this.$alert(response.data.message,"","success");
          //this.$alertify.success(response.data.message)
        })
        .catch((httpException) => {
          this.opened.splice(0, 1)
          this.changepopupStatusFlag = false;
          console.error('exception is:::::::::', httpException)
        })
    },
    onSubmit(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.changeClientBusinessStatus('reject')
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    clear(){
      this.rejectReson = '';
      this.commnet = '';
      this.searchapproval = '';
      this.approvalstatus1 = '';
      this.approvalListing = [];
      this.pageno = 0;
      this.pagecount = 0;
      this.resultCount = '';
      this.$refs.paginate.selected = 0;
      this.$validator.reset();
      this.searchapprovalitem();
      this.changeStatsuData = '';
    },
    traseIP(){
      let data = {
            "projectname": this.project,
            "type": "web",
            "userid": this.localuserid,
            "username":this.username,
            "meta" : {
              "event" : "approvalflow"
            }
        }
      axios({
              method: 'POST',
              'url': apiUrl.iptracker_url + 'UserTracker',
              'data': data
          })
          .then(async result => {
            if(result.data.code == 100){
              return true;
            }else {
              return false;
              //this.$alertify.success(result.data.message);
              //this.$alert(result.data.message,"","success");
            }
          }, error => {
            //this.$alertify.success("Unable to track IP Address");
            //this.$alert("Unable to track IP Address.","","error");
            console.error('exception is:::::::::', error)
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/cargoclient/approvalflow/approvalflow-tab/approval/approval.component.js